import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from "react";
import getClassNameFactory from "../../../../utilities/classNames";
import classNames from "classnames";
import ArrowLeftIcon from "@dcl/icons/esm/ui/arrow-left";
import ArrowRightIcon from "@dcl/icons/esm/ui/arrow-right";

var NavItem = function NavItem(_ref) {
  var ariaLabel = _ref.ariaLabel,
      borderlessAtStandard = _ref.borderlessAtStandard,
      direction = _ref.direction,
      disabled = _ref.disabled,
      href = _ref.href,
      onClick = _ref.onClick,
      rest = _objectWithoutProperties(_ref, ["ariaLabel", "borderlessAtStandard", "direction", "disabled", "href", "onClick"]);

  var getClassName = getClassNameFactory(NavItem.displayName);
  var ItemInnerName = "span";

  var itemInnerProps = _objectSpread({}, rest);

  if (!disabled) {
    if (href) {
      ItemInnerName = "a";
      itemInnerProps.href = href;
    } else if (onClick) {
      // this condition never happens, since Pagination supplies it an href prop
      ItemInnerName = "button";
      itemInnerProps.onClick = onClick;
    }
  }

  return /*#__PURE__*/React.createElement("li", {
    className: getClassName({
      modifiers: classNames(_defineProperty({
        borderlessAtStandard: borderlessAtStandard
      }, direction, true)),
      states: classNames({
        disabled: disabled
      })
    })
  }, /*#__PURE__*/React.createElement(ItemInnerName, _extends({
    "aria-label": ariaLabel,
    className: getClassName({
      descendantName: "inner",
      states: classNames({
        disabled: disabled
      })
    })
  }, itemInnerProps), direction === "left" && /*#__PURE__*/React.createElement("span", {
    className: getClassName({
      descendantName: "icon"
    })
  }, /*#__PURE__*/React.createElement(ArrowLeftIcon, null)), direction === "right" && /*#__PURE__*/React.createElement("span", {
    className: getClassName({
      descendantName: "icon"
    })
  }, /*#__PURE__*/React.createElement(ArrowRightIcon, null))));
};

NavItem.displayName = "Pagination.NavItem";
NavItem.defaultProps = {
  disabled: false
};
export default NavItem;